import { Component, computed, effect, inject, signal, untracked } from "@angular/core"
import { ContentType } from "redlineLibs"
import { EditorService } from "../services/editor.service"
import { SaveIconComponent } from "../../shared/save-icon.component"
import { UiCheckboxComponent } from "ui-checkbox"
import { UiInheritDirective } from "ui-inherit"

type Input = {
  selected: boolean
  identifier: ContentType
  label: string
}

@Component({
  imports: [
    SaveIconComponent,
    UiInheritDirective,
    UiCheckboxComponent,
  ],
  standalone: true,
  template: `
    <div class="column">
      <div>
        Content Type(s):
      </div>
      @for (input of inputs(); track input.identifier) {
        <div class="row">
          <lib-ui-checkbox
            [name]="name"
            [identifier]="input.identifier"
            [label]="input.label"
            [selected]="input.selected"
            (changes)="changes($event, input.identifier)"
            inherit
          />
          <e2e-save-icon [modelChange]="modelChange()[input.identifier]" />
        </div>
      }
    </div>
  `,
  selector: "e2e-editor-content-types",
})
export class EditorContentTypesComponent {
  private editorService = inject(EditorService)

  name = "content-type"

  sourceArrayWritable = signal<ContentType[]>([])
  modelChange = signal<{ [key: string]: any }>({})

  inputs = computed(
    () =>
      this.data.map((item) => ({
        selected: this.sourceArrayWritable().includes(item.identifier),
        identifier: item.identifier,
        label: item.label,
      })) as Input[],
  )

  constructor() {
    effect(() => {
      const sourceArrayInput = this.editorService.contentTypes()
      untracked(() => !this.sourceArrayWritable().length && this.sourceArrayWritable.set(sourceArrayInput))
    })
  }

  changes(event: boolean, identifier: ContentType) {
    this.modelChange.update((model) => ({ ...model, [identifier]: event }))
    this.sourceArrayWritable.update((sourceArray) => {
      if (event) {
        return [...sourceArray, identifier]
      }
      const index = sourceArray.findIndex((item) => item === identifier)
      if (!event && index !== -1) {
        // If the value exists in the array, remove it
        return [...sourceArray.slice(0, index), ...sourceArray.slice(index + 1)]
      }
      return sourceArray
    })
    const content = this.editorService.editorContent()
    if (content) {
      this.editorService.queueEditor({
        ...content,
        status: {
          ...content.status,
          contentTypes: this.sourceArrayWritable(),
        },
      })
    }
  }

  get data(): { label: string; identifier: ContentType }[] {
    return [
      // {
      //   label: "Contributed",
      //   identifier: ContentType.CONTRIBUTED,
      // },
      {
        label: "Local Map",
        identifier: ContentType.LOCAL_MAP,
      },
      {
        label: "Timeline",
        identifier: ContentType.TIMELINE,
      },
    ]
  }
}
